import { Modal } from '../../../../core/components/templates/Modal';
import Player from '../../../../core/components/molecules/Player';
import { MODAL_VIDEOS_VIMEO_ALLOWED } from '../../../../core/constants/modal-videos';

interface AboutPlanModalProps {
  isOpen: boolean;
  onClose: () => void;
}

function AboutPlanModal({ isOpen, onClose }: AboutPlanModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size='md'
      title='Como funciona o Plano Adaptativo?'
    >
      <Player
        playerType='vimeo'
        className='h-[265px]'
        token={MODAL_VIDEOS_VIMEO_ALLOWED.PLANO_ADAPTATIVO.token}
        initialTime={0}
      />
    </Modal>
  );
}

export { AboutPlanModal };
